import Head from 'next/head';
import { GetServerSideProps } from 'next';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import previewMain from '../../public/preview/preview-main.png';
import { WorksProps } from '../works/works';
import { Footer, Header } from '../../components';
import ProfePage from '../profe-page/profe-page';
import staticWorks from '../../utils/works';
import menu from '../../utils/menu';
import {
  androidAwardsData,
  androidDevtoolsData,
  androidIntroData,
  androidServiceData,
  androidTechData,
} from './data';

export default function WorksPage({ works }: WorksProps) {
  return (
    <>
      <Head>
        <title>
          Mavinx Android App Development: Harnessing the Power of the Android
          Platform
        </title>
        <meta
          property="og:title"
          content="Mavinx Android App Development: Harnessing the Power of the Android Platform"
        />
        <meta property="og:image" content={`${previewMain.src}`} />
        <meta name="twitter:image" content={`${previewMain.src}`} />
        <meta
          property="og:image:alt"
          content="Mavinx Android App Development: Harnessing the Power of the Android Platform"
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:description"
          content="Mavinx's Android app development services use the power of the Android platform to produce creative and effective mobile solutions. Explore our Java and Kotlin programming, Android SDKs, UI/UX design, and Google Play Store guidelines knowledge. Learn how our Android development team uses technical brilliance, creativity, and user-centric design to create smooth and feature-rich Android apps. Mavinx brings your ideas to life using the Android environment on smartphones, tablets, wearables, and smart TVs."
        />
        <meta
          name="description"
          content="Mavinx's Android app development services use the power of the Android platform to produce creative and effective mobile solutions. Explore our Java and Kotlin programming, Android SDKs, UI/UX design, and Google Play Store guidelines knowledge. Learn how our Android development team uses technical brilliance, creativity, and user-centric design to create smooth and feature-rich Android apps. Mavinx brings your ideas to life using the Android environment on smartphones, tablets, wearables, and smart TVs."
        />

        <meta
          name="keywords"
          content="Android app development services, Mavinx Android development, Android platform, innovative mobile solutions, Java programming, Kotlin programming, Android SDKs, UI/UX design, Google Play Store guidelines, technical excellence, creativity, user-centric design, feature-rich apps, smartphones, tablets, wearables, smart TVs, Android ecosystem, trusted partner, Mavinx Android app development"
        />
      </Head>
      <Header appearance="transparent" appearanceLogo="primary" menu={menu} />
      <ProfePage
        awards={androidAwardsData}
        works={[{ ...works[0] }, { ...works[5] }]}
        intro={androidIntroData}
        info="We are experts in all kinds of Android mobile development. <br />  Mavinx has been providing Android App Development Services for the past 5 years and got the majority of its experience across multiple areas. We are always ready to become your helper in the custom app mobile development for Android."
        tecnologic={androidTechData}
        service={androidServiceData}
        devtool={androidDevtoolsData}
      />
      <Footer />
    </>
  );
}

export const getServerSideProps: GetServerSideProps<WorksProps> = async () => {
  try {
    const works = staticWorks;
    return {
      props: {
        works,
      },
    };
  } catch {
    return {
      notFound: true,
    };
  }
};
